import { type Common } from './common.js';
import type * as StandardNoteField from './models/standardNoteField.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(): Promise<StandardNoteField.StandardNoteField[]> {
    const url = this.common.constructPath(`/standard-note-fields`);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<StandardNoteField.StandardNoteField> {
    const url = this.common.constructPath(`/standard-note-fields/${id}`);
    return await this.common.getJSON(url);
  }

  async create(
    values: StandardNoteField.CreateValues
  ): Promise<StandardNoteField.StandardNoteField> {
    const url = this.common.constructPath(`/standard-note-fields`);
    return await this.common.postJSON(url, values);
  }

  async update(
    id: string,
    values: StandardNoteField.UpdateValues
  ): Promise<StandardNoteField.StandardNoteField> {
    const url = this.common.constructPath(`/standard-note-fields/${id}`);
    return await this.common.patchJSON(url, values);
  }

  async remove(id: string): Promise<{ success: true }> {
    const url = this.common.constructPath(`/standard-note-fields/${id}`);
    return await this.common.deleteJSON(url);
  }
}
